import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useIsFormDisabled } from "shared/components/form/FormStateProvider";

export type SubmitButtonProps = Omit<ButtonProps, "type">;

export const FormSubmitButton: React.FC<
  React.PropsWithChildren<SubmitButtonProps>
> = ({ children, isLoading, isDisabled, ...props }) => {
  const { t } = useTranslation(["common"]);
  const isFormDisabled = useIsFormDisabled() || isDisabled;
  const {
    formState: { isSubmitting },
  } = useFormContext();
  const childrenOrDefault = children ?? t("common:saveProgress");
  return (
    <Button
      {...props}
      data-ls-enabled={true}
      data-public={true}
      type="submit"
      isLoading={isSubmitting || isLoading}
      isDisabled={isFormDisabled || isDisabled}
    >
      {childrenOrDefault}
    </Button>
  );
};
